import {
    styled,
    Card as MuiCard,
    CardContent as MuiCardContent,
    Paper as MuiPaper,
    CardActions as MuiCardActions,
    Button as MuiButton,
    useTheme,
    Theme,
} from "@mui/material";
import { CustomThemeOptions } from "@js/components/CustomColors/Colors";

export const PaperHeader = styled(MuiPaper)(() => {
    const theme: CustomThemeOptions & Theme = useTheme();

    return {
        borderRadius: "10px",
        border: `2px solid ${theme.palette.courseCard.main}`,
        padding: `${theme.spacing(2.5)} ${theme.spacing(0)}`,
        marginBottom: "4.5rem",
    };
});

export const PaperSection = styled(MuiPaper)(() => {
    const theme: CustomThemeOptions & Theme = useTheme();

    return {
        borderRadius: "10px",
        border: `2px solid ${theme.palette.courseCard.main}`,
        padding: `${theme.spacing(2.5)} ${theme.spacing(4)}`,
        marginBottom: "4.5rem",
    };
});

export const PaperSectionTitle = styled(MuiPaper)(() => {
    const theme: CustomThemeOptions & Theme = useTheme();

    return {
        borderRadius: "8px",
        border: `2px solid ${theme.palette.courseCard.main}`,
        padding: theme.spacing(1),
        textAlign: "center",
    };
});

export const Card = styled(MuiCard)(() => {
    const theme: CustomThemeOptions & Theme = useTheme();

    return {
        border: `2px solid ${theme.palette.courseCard.main}`,
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "17.5rem",
    };
});

export const CardContent = styled(MuiCardContent)(() => {
    const theme: CustomThemeOptions & Theme = useTheme();
    return {
        paddingTop: theme.spacing(2.5),
        minHeight: "5.5rem",
        backgroundColor: theme.palette.primary.light,
        minWidth: "100%",
        textAlign: "center",
    };
});

export const CardActions = styled(MuiCardActions)(() => {
    const theme: CustomThemeOptions & Theme = useTheme();

    return {
        justifyContent: "center",
        width: "17.5rem",
    };
});

export const StartModuleButton = styled(MuiButton)(() => {
    const theme: CustomThemeOptions & Theme = useTheme();

    return { textTransform: "capitalize", fontWeight: 700, marginTop: "-2rem" };
});
